<h4 class="text-dark mt-1 font-16 font-md-18">{{ sentence?.description }}</h4>
<p
  [innerHTML]="sentence?.consentText"
  class="text-left whitespace-pre-line my-10 font-12 font-md-14"
></p>
